export default class Ticket {
    constructor(header = '',
                content = '',
    ) {
        this.header = header;
        this.content = content;
    }
}